<template>
	<div class="my-orders-all-container">
		<OrderTracking v-if="status_tracking" @closeTracking="status_tracking = $event" :formRestaurant="true"></OrderTracking>
		<MapTracking v-if="map_tracking" @closeTracking="map_tracking = $event" :formRestaurant="true"></MapTracking>

		<div class="my-orders-template" v-show="!status_tracking && !map_tracking">
			<div class="header-componenet">
				<div class="order-options-back">
					<i class="fas fa-chevron-left" @click="close()"></i>
				</div>
				<div class="order-title-header">
					<h4>Mis ordenes</h4>
				</div>
			</div>
			<div class="menu-change-options">
				<div class="options-change item1" @click="styleMenu1()">
					<h4>Anteriores</h4>
				</div>
				<div class="options-change item2" @click="styleMenu2()">
					<h4>En proceso</h4>
				</div>
			</div>
			<div class="list-orders-state">
				<div class="no-orders-view" v-if="list_orders.length == 0">
					<i class="fas fa-exclamation"></i>
					<h4>oops!</h4>
					<h5>No has realizado ordenes aun</h5>
				</div>
				<div class="single-order-historial"  v-for="(item, index) in list_orders" >
					<div class="order-historial-header">
						<div class="order-basic-info">
							<h4>Orden #{{item.id_order}}</h4>
							<h5>Entregada {{item.fecha}}</h5>
						</div>
						<div class="order-extend-option">
							<!--<i class="fas fa-chevron-down" @click="setStyleOptions()"></i>-->
						</div>
					</div>
					<div class="order-detail-info" v-bind:id="'single_order_'+index">
						<li v-for="detalle in item.details">{{detalle.name_product}}</li>
						<div class="order-total">
							<h4>Total:</h4>
							<h5>${{Intl.NumberFormat("de-DE").format( item.total)}}</h5>
						</div>
					</div>
					<div class="order-button">
						<button @click="cloneOrder(item)">Repetir pedido</button>
						<button @click="setStyleOptions(index)">Ver detalles</button>
					</div>
				</div>
				<div class="single-order-historial2" v-for="(item, index) in list_orders_process">
					<div class="order-historial-header">
						<div class="order-basic-info">
							<h4>Orden #{{item.id_order}}</h4>
							<h5>Entregada el {{item.details[0].created_at.substr(0,10)}}</h5>
						</div>
						<div class="order-extend-option">
							<!--<i class="fas fa-chevron-down" @click="setStyleOptions()"></i>-->
						</div>
					</div>
					<div class="order-detail-info" v-bind:id="'single_order_2'+index">
						<li v-for="detalle in item.details">{{detalle.name_product}}</li>
						<div class="order-total">
							<h4>Total:</h4>
							<h5>${{Intl.NumberFormat("de-DE").format(item.total)}}</h5>
						</div>
					</div>
					<div class="order-button">
						<button @click="popupTracking(item)">Seguir mi pedido</button>
						<button @click="setStyleOptions2(index)">Ver detalles</button>
						<button v-if="item.id_type_status == 95" @click="mapTracking(item)">Ver mapa</button>
					</div>
				</div>
			</div>
			<div class="separator"></div>
			<!--<div class="order-history">
				<div class="single-order-history">
					<div class="id-order">
						<h4><i class="fas fa-circle"></i> Orden #25674</h4>
					</div>
					<div class="order-history-detail">
						<h4><span>Dirección:</span> Calle 26 #23-23</h4>
						<h4><span>Método de pago:</span> Efectivo</h4>
						<h4><span>Total del pedido:</span> 35.000</h4>
					</div>
					<div class="single-order-button">
						<button>Seguir mi pedido</button>
					</div>
				</div>
			</div>-->
			<!--<div class="fixed-menu">
				<div class="single-menu-option">
					<i class="fas fa-shopping-cart"></i>
					<h4>Mis pedidos</h4>
				</div>
				<div class="single-menu-option">
					<i class="fas fa-tags"></i>
					<h4>Promociones</h4>
				</div>
				<div class="single-menu-option">
					<i class="far fa-bell"></i>
					<h4>Referir y ganar</h4>
				</div>
			</div>-->
		</div>
	</div>
</template>

<style scoped>
		@import url('https://fonts.googleapis.com/css2?family=Poppins&display=swap');

		*:focus{
			outline: none !important;
		}

		.no-orders-view{
			width: 100%;
			text-align: center;
			padding-top: 35%;
		}

		.no-orders-view i{
			font-size: 40px;
			color: #B5B7B8;
			margin-bottom: 10px;
		}

		.no-orders-view h4{
			font-family: 'Poppins', sans-serif;
			font-weight: 600;
			font-size: 25px;
			color: #B5B7B8;
			margin-bottom: 5px;
		}

		.no-orders-view h5{
			font-family: 'Poppins', sans-serif;
			font-weight: 500;
			font-size: 16px;
			color: #B5B7B8;
		}

		.order-button{
			width: 100%;
			border: 1px solid #F6F9FF;
			padding:12px 0px;
			display: flex;
			justify-content: center;
			align-items: center;
		}

		.order-button button{
			width: 50%;
			background: transparent;
			border: none;
			font-size: 14px;
			font-family: 'Poppins', sans-serif;
			font-weight: 500;
			color: #236FC3;
		}

		.order-button button:nth-child(1){
			border-right: 1px solid #F6F9FF;
		}

		.header-componenet{
			width: 100%;
			padding: 20px 15px;
		}

		.menu-change-options{
			width: 100%;
			display: flex;
			justify-content: center;
			align-items: center;
		}

		.single-order-historial{
			background: #fff;
			border-radius: 7px;
			width: 95%;
			overflow: hidden;
			box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px;
			margin: 0px auto 15px;
		}

		.single-order-historial2{
			background: #fff;
			border-radius: 7px;
			width: 95%;
			overflow: hidden;
			box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px;
			margin: 0px auto 15px;
		}

		.order-historial-header{
			width: 100%;
			display: flex;
			justify-content: space-between;
			align-items: center;
			padding: 10px 15px;
		}

		.order-detail-info{
			width: 100%;
			height: 0;
			padding: 0px 15px;
			text-align: left;
			transition: height .5s ease-in-out;
			overflow: hidden;
		}

		.order-detail-info li{
			font-family: 'Poppins', sans-serif;
			font-size: 13px;
		}

		.order-total{
			width: 100%;
			display: flex;
			justify-content: space-between;
			align-items: center;
			padding: 5px;
		}

		.altura{
			height: 100% !important;
		}

		.order-total h4{
			color: #3A3A3A;
			margin-bottom: 0;
			font-size: 13px;
			font-weight: 600;
			font-family: 'Poppins', sans-serif;
		}

		.order-total h5{
			color: #3A3A3A;
			margin-bottom: 0;
			font-size: 13px;
			font-weight: 600;
			font-family: 'Poppins', sans-serif;
		}

		.order-basic-info{
			width: 90%;
			text-align: left;
		}

		.order-basic-info h4{
			color: #3A3A3A;
			margin-bottom: 0;
			font-size: 15px;
			font-weight: 600;
			font-family: 'Poppins', sans-serif;
		}

		.order-basic-info h5{
			color: #3A3A3A;
			margin-bottom: 0;
			font-size: 13px;
			font-weight: 500;
			font-family: 'Poppins', sans-serif;
		}

		.order-extend-option{
			width: 10%;
			text-align: center;
		}

		.options-change{
			width: 50%;
			text-align: center;
			padding-bottom: 15px;
		}

		.list-orders-state{
			width: 100%;
			min-height: 80vh;
			padding: 25px 20px;
			background: #F6F9FF;
			/*display: flex;
			justify-content: center;
			align-items: flex-start;
			flex-wrap: wrap;*/
		}

		.options-change h4{
			color: #ADADAD;
			margin-bottom: 0;
			font-size: 15px;
			font-weight: 600;
			font-family: 'Poppins', sans-serif;
		}

		.separator{
			width: 100%;
			height: 3px;
			background: #FBFCFE;
		}

		.my-orders-template{
			width: 100%;
			height: auto;
		}

		.order-options-back, .order-title-header{
			width: 100%;
			text-align: left;
		}

		.order-options-back i{
			color: #3D4762;
		}

		.order-title-header h4{
			color: #3D4762;
			padding-top: 5px;
			margin-bottom: 0;
			font-size: 23px;
			font-weight: 600;
			font-family: 'Poppins', sans-serif;
		}

		.order-history{
			width: 100%;
			padding: 15px 0px;
			display: flex;
			justify-content: center;
			align-items: center;
			flex-wrap: wrap;
		}

		.single-order-history{
			background: #F6F9FF;
			border-radius: 10px;
			margin-bottom: 20px;
			width: 90%;
			padding: 15px 20px;
			/*box-shadow: rgba(0, 0, 0, 0.15) 1.95px 1.95px 2.6px;*/
			box-shadow: rgba(0, 0, 0, 0.05) 0px 1px 2px 0px;
		}

		.id-order{
			width: 100%;
			text-align: left;
			padding-bottom: 10px;
		}

		.id-order i{
			color: #38C65A;
			font-size: 13px;
			margin-right: 5px;
		}

		.id-order h4{
			color: #3D4762;
			margin-bottom: 0;
			font-size: 16px;
			font-weight: 600;
			font-family: 'Poppins', sans-serif;
		}

		.order-history-detail{
			width: 100%;
			text-align: left;
		}

		.order-history-detail span{
			color: #A5A9B4;
			margin-bottom: 0;
			margin-right: 10px;
			font-size: 14px;
			font-weight: 500;
			font-family: 'Poppins', sans-serif;
		}

		.order-history-detail h4{
			color: #3D4762;
			margin-bottom: 5px;
			font-size: 14px;
			font-weight: 500;
			font-family: 'Poppins', sans-serif;
		}

		.single-order-button{
			width: 100%;
			text-align: left;
			padding-top: 8px;
		}

		.single-order-button button{
			background: #E2F1FF;
			padding: 9px 30px;
			border-radius: 7px;
			color: #236FC3;
			border: none;
			font-size: 16px;
			font-family: 'Poppins', sans-serif;
			font-weight: 600;
		}

		.order-history .single-order-history:not(.single-order-history:nth-child(1)) button{
			background: #E1EFEC;	
			color: #21A17C;
		}

		.order-history .single-order-history:not(.single-order-history:nth-child(1)) i{	
			color: #236FC3;
		}

		.fixed-menu{
			width: 85%;
			margin: 0 auto;
			position: fixed;
			bottom: 15px;
			left: 0;
			right: 0;
			padding: 10px 10px;
			border-radius: 7px;
			background: #fff;
			box-shadow: rgba(17, 17, 26, 0.05) 0px 4px 16px, rgba(17, 17, 26, 0.05) 0px 8px 32px;
			display: flex;
			justify-content: space-between;
			align-items: center;
		}

		.single-menu-option{
			width: 33%;
			text-align: center;
			display: block;
		}

		.single-menu-option i{
			font-size: 18px;
			color: #236FC3;
		}

		.single-menu-option h4{
			font-size: 12px;
			font-family: 'Poppins', sans-serif;
			font-weight: 500;
			color: #3D4762;
		}

		.rotate{
			transform: rotate(180deg);
		}

		.black-color{
			color: #000 !important;
		}

		.border-comp{
			border-bottom: 2px solid #236FC3 !important;
		}
</style>

<script>
	import axios from 'axios';
	import OrderTracking from './OrderTracking.vue';
	import MapTracking from './MapTracking.vue';
	export default{
		components: {
		    OrderTracking,
			MapTracking
		},
		data(){
			return{
				status_tracking: false,
				map_tracking: false,
				detalles: [],
				id_companie : localStorage.getItem('companie_id'),
				telefono: localStorage.getItem('telefono') ? localStorage.getItem('telefono') : "",
				list_orders: [],
				carrito:[],
			    list_product:[],
				list_orders_process:[],
				contador: 0,
				contador2: 0
			}
		},
		methods:{
			popupTracking(order){
                localStorage.setItem('id_order',order.id_order);
	          	localStorage.setItem('id_punto', order.id_point);
	          	if (order.id_table > 0) {
	          		localStorage.setItem(`id_estado_order_${this.id_companie}_${order.id_table}`,order.id_type_status);
	          	}else{
	          		localStorage.setItem(`id_estado_order_${this.id_companie}`,order.id_type_status);
	          	}
	          	this.$emit('closeMenu', false);
	          	this.status_tracking =	true;
			},
			mapTracking(order){
                localStorage.setItem('id_order',order.id_order);
	          	localStorage.setItem('id_punto', order.id_point);
	          	// if (order.id_table > 0) {
	          	// 	localStorage.setItem(`id_estado_order_${this.id_companie}_${order.id_table}`,order.id_type_status);
	          	// }else{
	          	// 	localStorage.setItem(`id_estado_order_${this.id_companie}`,order.id_type_status);
	          	// }
	          	this.$emit('closeMenu', false);
	          	this.map_tracking =	true;
			},
			cloneOrder(order){
			  var self =this
			  this.carrito=[]
			  let new_product=null
			  
              order.details.forEach((detalle)=>{
              	    var name_combination=""
              	    var adition = []
              	    if (detalle.product.status) {
                        if (detalle.product_combination)name_combination=detalle.product_combination.variant
	              	    if(detalle.additions.length>0){
	              	      detalle.additions.forEach((d)=>{
	              	      	adition.push({
	              	    	  id_product_addition_detail: d.id_product_addition_detail,
				    		  option : d.detail.name,
				    		  value : d.value,
				    		  quantity: d.quantity
	              	    	});
	              	      })
	              	    }
	              	    	
	                    new_product = {
				          'id_product' : detalle.id_product,
				          'name_product' : detalle.name_product,
				          'valor': parseInt(detalle.value),
				          'cantidad' : detalle.quantity,
				          'descuento': 0,
				          'combination': name_combination,
				          'addition': JSON.stringify(adition),
				          'estado' : detalle.product.status
				        } 

				        self.carrito.push(new_product);
              	    }
              	    
              });

               this.$emit('orderClone', self.carrito);
			},
			getOrderByClients(){
				if (this.telefono != "") {
					axios
				    .get('https://back.vinapp.co/api/get-orders-by-clients/'+this.telefono+"/"+this.id_companie)
				    .then( res =>{
				      this.list_orders = res.data;
				    })
				    .catch( err => {
				      console.log(err);
				    });
				}
				
			},
			getOrderProcess(){
				if (this.telefono != "") {
					axios
					  .get('https://back.vinapp.co/api/get-order-process/'+this.telefono+"/"+this.id_companie)
					  .then( res =>{
					    this.list_orders_process = res.data;
					    this.detalles = this.list_orders_process.details;
					  })
					  .catch( err => {
					    console.log(err);
					  });
			    }
			},
			close(){
				this.$emit('closeMenu', true);
				this.$emit('closeManagment',false);
			},
			setStyleOptions(pos){
				if (this.contador == 0) {
					$(`#single_order_${pos}`).addClass("altura");
					this.contador ++;
				}else{
					$(`#single_order_${pos}`).removeClass("altura");
					this.contador= 0 ;
				}
			},
			setStyleOptions2(pos){
				if (this.contador2 == 0) {
					$(`#single_order_2${pos}`).addClass("altura");
					this.contador2 ++;
				}else{
					$(`#single_order_2${pos}`).removeClass("altura");
					this.contador2= 0 ;
				}
			},
			styleMenu1(){
				$(".item1 h4").addClass("black-color");
				$(".item1").addClass("border-comp");
				//removemos los estilos de la segunda opcion
				$(".item2 h4").removeClass("black-color");
				$(".item2").removeClass("border-comp");
				$(".single-order-historial2").hide();
				$(".single-order-historial").show();
				$(".no-orders-view").show();
			},
			styleMenu2(){
				//removemos las clases de la primera opcion
				$(".item1 h4").removeClass("black-color");
				$(".item1").removeClass("border-comp");
				//añadimos las nuevas a la segunda
				$(".item2 h4").addClass("black-color");
				$(".item2").addClass("border-comp");
				$(".single-order-historial2").show();
				$(".single-order-historial").hide();
				$(".no-orders-view").hide();
				this.getOrderProcess();
			}
		},
		mounted(){
			this.styleMenu1();
			this.getOrderByClients();
		}
	}
</script>